import DiscordIcon from "../../../public/assets/logos/discord-mark.svg";

export default DiscordIcon;
